
export default [
    {
        path:'/resources',
        name:'resources',
        meta:{
            title:'RESOURCES'
        },
        component:() => import("../views/pages/resources/index.vue")
    },
    {
        path:'/governance',
        name:'governance',
        meta:{
            title:'GOVERNANCE'
        },
        component:() => import("../views/pages/governance/index.vue")
    },
    {
        path:'/publications',
        name:'publications',
        meta:{
            title:'PUBLICATIONS'
        },
        component:() => import("../views/pages/publications/index.vue")
    },
    {
        path:'/impact',
        name:'impact',
        meta:{
            title:'IMPACT'
        },
        component:() => import("../views/pages/impact")
    },
    {
        path:'/advert',
        name:'advert',
        meta:{
            title:'ADVERT'
        },
        component:() => import("../views/pages/advert/index.vue")
    }
]